import { render, staticRenderFns } from "./new-profile.vue?vue&type=template&id=7285ad3d&scoped=true&lang=pug&"
import script from "./new-profile.vue?vue&type=script&lang=js&"
export * from "./new-profile.vue?vue&type=script&lang=js&"
import style0 from "./new-profile.vue?vue&type=style&index=0&id=7285ad3d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7285ad3d",
  null
  
)

export default component.exports